/** 釋放 Material 與其上所有貼圖參照，避免 VRAM 洩漏 */
export function disposeMaterial(material) {
    material.dispose()
    for (const key of Object.keys(material)) {
        const value = material[key]
        if (value && typeof value === 'object' && 'isTexture' in value) {
            value.dispose()
        }
    }
}
